<template>
    <div>
        <slot name="button" :openDialog="openDialog">
            <Button rounded @click="openDialog" :icon="'pi ' + icon" :label="label" data-cy="open" />
        </slot>
        <Dialog v-model:visible="open" modal :dismissable-mask="outsideDismiss" :position="modalPosition">
            <template #container="{ closeCallback }">
                <div class="p-2" :style="{ width, height }">
                    <slot></slot>
                    <slot name="close" :closeCallback="closeCallback">
                        <div
                            class="closeButton flex justify-center items-center"
                            @click="closeCallback"
                            data-cy="close"
                        >
                            <span class="pi pi-times"></span>
                        </div>
                    </slot>
                </div>
            </template>
        </Dialog>
    </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

// Defaults live in the destructure, not in withDefaults(): wrapping defineProps in
// withDefaults() disables reactive props destructure, which froze `icon`, `label` and
// `outsideDismiss` at their mount-time values while the props that were *not* destructured
// (width/height/modalPosition) stayed reactive. Every current caller passes static
// literals so nothing was visibly broken, but the compiler warned about it on every build.
const {
    icon,
    label = "",
    outsideDismiss = true,
    width = "95vw",
    height,
    modalPosition = "center",
} = defineProps<{
    icon?: string;
    label?: string;
    outsideDismiss?: boolean;
    width?: string;
    height?: string;
    modalPosition?: string;
}>();
const open = ref(false); // by implementing this as a model we could let the slot also close the window again

const openDialog = () => {
    open.value = true;
};
</script>
<style scoped>
.closeButton {
    cursor: pointer;
    position: absolute;
    top: -0.8rem;
    left: -0.8rem;
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 50%;
}
.generateButton {
    margin-top: 5px;
}
</style>
